const helpers = require('./helpers')

module.exports.setUpHotjarScripts = function (hotjarId) {
  const externalSrc = '//static.hotjar.com/c/hotjar-'
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }
  (function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}
    h._hjSettings={hjid:hotjarId,hjsv:5}
    a=o.getElementsByTagName('head')[0]
    r=o.createElement('script');r.async=1
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv
    a.appendChild(r)
  })(window,document,externalSrc,'.js?sv=')
}
